import { Button, PageHeader } from "components/common";
import downloadFileIcon from "assets/images/downloadFile.svg";
import uploadFileIcon from "assets/images/uploadFile.svg";
import visibilityOffIcon from "assets/images/eye_off.svg";
import areaChartIcon from "assets/images/areaChart.svg";
import { getTabs } from "pages/tradingDocuments/shared/utils/getTabs";
import { salesInvoices } from "components/common/moduleNavigation/moduleConfig/finances/routes/salesInvoices";
import { BottomBarOptions } from "./BottomBarOptions";
import { useToggle } from "hooks";
import { CurrentlyPrintedReceiptsModal } from "./currentlyPrintedReceiptsModal/CurrentlyPrintedReceiptsModal";
import { LastPrintedReceiptsModal } from "./lastPrintedReceiptsModal/LastPrintedReceiptsModal";
import { AmountSummaryModal } from "./amountSummaryModal/AmountSummaryModal";
import { useFinancesAmountSummary } from "api/trading-documents/hooks";

interface Props {
  additionalListParams: {
    [x: string]: string;
  };
  refetchList: () => void;
  search: string;
}

export const ListHeader = ({ additionalListParams, refetchList, search }: Props) => {
  const currentlyPrintedReceiptsModal = useToggle();
  const lastPrintedReceiptsModal = useToggle();
  const amountSummaryModal = useToggle();

  const { data: amountSummary, isLoading } = useFinancesAmountSummary(search);

  return (
    <div>
      <PageHeader
        actionButtons={
          <div className="d-flex align-items-center gap-1">
            <Button kind="transparent-black" size="square-s">
              <div className="btnBase btnBaseSmall">
                <img
                  alt="Importuj plik"
                  src={uploadFileIcon}
                  style={{ height: "16px", width: "16px" }}
                />
              </div>
            </Button>
            <Button kind="transparent-black" size="square-s">
              <div className="btnBase btnBaseSmall">
                <img
                  alt="Pobierz plik"
                  src={downloadFileIcon}
                  style={{ height: "16px", width: "16px" }}
                />
              </div>
            </Button>
            <span className="line-divider lineDividerMargin" />
            <Button kind="transparent-black" size="square-s">
              <div className="btnBase btnBaseSmall">
                <img
                  alt="Wyłącz widoczność"
                  src={visibilityOffIcon}
                  style={{ height: "16px", width: "16px" }}
                />
              </div>
            </Button>
            <Button kind="transparent-black" size="square-s">
              <div className="btnBase btnBaseSmall">
                <img alt="Wykres" src={areaChartIcon} style={{ height: "16px", width: "16px" }} />
              </div>
            </Button>
          </div>
        }
        additionalListParams={additionalListParams}
        bottomBarButtons={
          <BottomBarOptions
            amountSummary={amountSummary}
            amountSummaryModal={amountSummaryModal}
            currentlyPrintedReceiptsModal={currentlyPrintedReceiptsModal}
            isLoading={isLoading}
            lastPrintedReceiptsModal={lastPrintedReceiptsModal}
          />
        }
        createButton={{ label: "Utwórz fakturę", onClick: () => {} }}
        searchInput={{
          label: "Szukaj wśród faktur sprzedażowych",
          tags: [
            {
              name: "issueDateFrom",
              label: "data wystawienia (od)",
              value: "2023-08-01",
            },
            {
              name: "issueDateTo",
              label: "data wystawienia (do)",
              value: "2023-08-04",
            },
          ],
        }}
        tabs={{
          list: getTabs(),
          routesRoot: `finances/${salesInvoices.url}`,
          urlSpan: "list",
        }}
        viewLabel="SALES_INVOICES"
      />
      {currentlyPrintedReceiptsModal.isOpen && (
        <CurrentlyPrintedReceiptsModal close={currentlyPrintedReceiptsModal.close} />
      )}
      {lastPrintedReceiptsModal.isOpen && (
        <LastPrintedReceiptsModal close={lastPrintedReceiptsModal.close} />
      )}
      {amountSummaryModal.isOpen && amountSummary && (
        <AmountSummaryModal amountSummary={amountSummary} close={amountSummaryModal.close} />
      )}
    </div>
  );
};
